export default __webpack_public_path__ + "navigation-examples-route-alerts-thumbnail-480-5450acdc91cf3e0a272e63e1d30ce3a7.png";